var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paycard-wrap"},[_c('swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.slideData),function(item,index){return _c('swiper-slide',{key:item.id},[_c('div',{staticClass:"image-area"},[_c('img',{attrs:{"src":item.cardImg,"alt":""}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }